
<keep-alive>
  <transition name="navi" @before-enter="willShowView">
    <component :is="currentComponentName" ref="navView" v-bind="currentProps"/>
  </transition>
</keep-alive>
